export const CREATE_PROVIDER = "CREATE_PROVIDER";
export const GET_PROVIDER_BY_USER = "GET_PROVIDER_BY_USER";
export const DELETE_PROVIDER = "DELETE_PROVIDER"
